import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeyMinus = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M13.643 4c-4.738 0-8.6 3.862-8.6 8.6v25.8c0 4.738 3.862 8.6 8.6 8.6h22.8c4.738 0 8.6-3.862 8.6-8.6V12.6c0-4.738-3.862-8.6-8.6-8.6h-22.8zm0 2h22.8c3.657 0 6.6 2.943 6.6 6.6v18.8c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6V12.6c0-3.657 2.943-6.6 6.6-6.6zm3.4 15v2h16v-2h-16zm-10 15.902a8.588 8.588 0 0 0 6.6 3.098h22.8a8.588 8.588 0 0 0 6.6-3.098V38.4c0 3.657-2.943 6.6-6.6 6.6h-22.8a6.585 6.585 0 0 1-6.6-6.6v-1.498z" />
    </svg>
);
export default SvgKeyMinus;
